import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

interface AddButtonProps {
  onClick: () => void;
}

const AddButton = ({ onClick }: AddButtonProps) => {
  return (
    <button onClick={onClick} className={cx('btn')}>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clipPath="url(#clip0_2736_13144)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.4502 18.5001V5.50006H12.5502V18.5001H11.4502Z"
            fill="#121619"
          />
          <path fillRule="evenodd" clipRule="evenodd" d="M5.5 11.4502H18.5V12.5502H5.5V11.4502Z" fill="#121619" />
        </g>
        <defs>
          <clipPath id="clip0_2736_13144">
            <rect width="13" height="13" fill="white" transform="translate(5.5 5.5)" />
          </clipPath>
        </defs>
      </svg>
    </button>
  );
};

export default AddButton;
